import { c as _c } from "react/compiler-runtime";
import { Button } from "@repo/ui/button";
export interface WizardNavigationProps {
  isFirstStep: boolean;
  isFinalStep: boolean;
  isPending: boolean;
  isAdvancing: boolean;
  isSubmitting: boolean;
  canAdvance: boolean;
  submitLabel: string;
  onBack: () => void;
  onNext: () => void;
}

/**
 * Back / Next / Submit button row for the form wizard.
 *
 * Back is hidden on the first step per the Figma spec. Next is disabled
 * until the user has supplied at least one value on the current step (the
 * caller is responsible for computing `canAdvance` via `form.Subscribe`).
 * Submit replaces Next on the final step and follows the same `canAdvance`
 * rule — previous steps were validated when the user clicked Next, so a
 * text-only final step can submit immediately.
 */
export const WizardNavigation = t0 => {
  const $ = _c(20);
  const {
    isFirstStep,
    isFinalStep,
    isPending,
    isAdvancing,
    isSubmitting,
    canAdvance,
    submitLabel,
    onBack,
    onNext
  } = t0;
  let t1;
  if ($[0] !== isFirstStep || $[1] !== isPending || $[2] !== onBack) {
    t1 = !isFirstStep && <Button type="button" variant="blue-outline" onClick={onBack} disabled={isPending}>Back</Button>;
    $[0] = isFirstStep;
    $[1] = isPending;
    $[2] = onBack;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== canAdvance || $[5] !== isAdvancing || $[6] !== isFinalStep || $[7] !== isPending || $[8] !== onNext) {
    t2 = !isFinalStep && <Button type="button" variant="blue-filled" onClick={onNext} disabled={isPending || isAdvancing || !canAdvance}>Next</Button>;
    $[4] = canAdvance;
    $[5] = isAdvancing;
    $[6] = isFinalStep;
    $[7] = isPending;
    $[8] = onNext;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== canAdvance || $[11] !== isFinalStep || $[12] !== isPending || $[13] !== isSubmitting || $[14] !== submitLabel) {
    t3 = isFinalStep && <Button variant="blue-filled" type="submit" disabled={!canAdvance || isSubmitting || isPending}>{isSubmitting || isPending ? "Submitting..." : submitLabel}</Button>;
    $[10] = canAdvance;
    $[11] = isFinalStep;
    $[12] = isPending;
    $[13] = isSubmitting;
    $[14] = submitLabel;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3) {
    t4 = <div className="mt-2 flex flex-wrap items-center gap-4">{t1}{t2}{t3}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};